import Component from "@tunnel-components/@pages/supervision/systems/home/component";
import * as React from "react";
import {
  SystemSettingsActionCreator,
  sectionzonesloadedresetactioncreator,
  setsectionsettingsresetactioncreator,
} from "@tunnel-store/index";
import { connect } from "react-redux";
import * as Lodash from "lodash";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name componentDidMount
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { boolean }      state.errorserver
     * @property { boolean }      state.loading
     */
    this.state = {
      errorserver: false,
      loading: false,
    };
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        this.setState((state: any): any => ({ errorserver: true }));
      }
      {
        /** Comparaison */
      }
    } else if (nextProps.data !== this.props.data) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ data: nextProps.data }));
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      errorserver: false,
      loading: false,
    }));
    this.props.setsectionsettingsresetactioncreator();
    this.props.sectionzonesloadedresetactioncreator();
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ loading: true });
    this.props
      .SystemSettingsActionCreator()
      .then(() => this.setState((state: any): any => ({ loading: false })))
      .then(() => {
        if (!Lodash.isUndefined(this.props.error)) {
          this.setState((state: any): any => ({ errorserver: true }));
        }
      });
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return <Component {...this.state} /*{...this.props}*/ />;
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    data: state.SystemSettings.data,
    error: state.SystemSettings.error,
    // loading: state.SystemSettings.loading
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  sectionzonesloadedresetactioncreator,
  setsectionsettingsresetactioncreator,
  SystemSettingsActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/systems/home/container.tsx